import React, { useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { fetchMerchandiseCategoryRemaining } from "../../../../../../redux/actions/catalog/catalog";
import { useAppDispatch, useAppSelector } from "../../../../../../redux/hooks";

import { PopUpForm } from "../../../../../common/popup/popUpForm/popUpForm";
import { validateDefaultForm } from "../../../utils/utils";
import { MasterMerchandiseCategoryForm } from "./form/form";
import { PopUpCodes } from "../../../../../../common/enum/PopUpCodes";
import { clearMasterPopUp } from "../../../../../../redux/reducers/resources/master/master";
import { resetMasterMerchandiseCategoryForm } from "../../../../../../redux/reducers/resources/master/merchandiseCategory/form";
import { postMasterMerchandiseCategory } from "../../../../../../redux/actions/resources/master/merchandiseCategory/merchandiseCategory";
import { RequiredFieldsMessage } from "../../../../../common/requiredMessage/requiredMessage";
interface IMasterMerchandiseCategoryFormController {
    widthPopUp: any;
    heigthPopUp: any;
}
export const MasterMerchandiseCategoryFormController: React.FC<IMasterMerchandiseCategoryFormController> = ({ heigthPopUp, widthPopUp }) => {
    const { showPopUp } = useAppSelector((state) => state.masterPopUp);
    const { form, loading } = useAppSelector((state) => state.masterMerchandiseCategoryForm);
    const { data } = useAppSelector((state) => state.catalog.merchandiseCategoryRemaining);
    const { t } = useTranslation("common", { keyPrefix: "MASTERS" });
    const dispatch = useAppDispatch();

    const onSavePopUp = () => {
        dispatch(postMasterMerchandiseCategory()).then((response: any) => {
            if (response) {
                onCancelPopUp();
            }
        });
    };
    const onCancelPopUp = () => {
        dispatch(clearMasterPopUp());
    };
    const onDimissed = () => {
        dispatch(resetMasterMerchandiseCategoryForm());
    };
    const title = useMemo(() => {
        if (showPopUp === PopUpCodes.CREATE) {
            return t("CREATE") + " " + t("BUTTON.MERCHANDISE_CATEGORY");
        } else if (showPopUp === PopUpCodes.UPDATE) {
            return t("UPDATE") + " " + t("BUTTON.MERCHANDISE_CATEGORY");
        }
        return "";
    }, [showPopUp]);

    const isDisabledButton = useMemo(() => {
        return validateDefaultForm(form, showPopUp === PopUpCodes.CREATE);
    }, [form, showPopUp]);

    const showNotData = useMemo(() => {
        return showPopUp === PopUpCodes.CREATE && !data.length ? true : false;
    }, [data, showPopUp]);

    useEffect(() => {
        showPopUp === PopUpCodes.CREATE && dispatch(fetchMerchandiseCategoryRemaining());
    }, [showPopUp]);

    return (
        <PopUpForm
            content={
                <MasterMerchandiseCategoryForm
                    selectorData={data}
                    showNotData={showNotData}
                />
            }
            title={title}
            isVisible={showPopUp === PopUpCodes.CREATE || showPopUp === PopUpCodes.UPDATE ? true : false}
            onCancel={onCancelPopUp}
            onSave={onSavePopUp}
            onDimissed={onDimissed}
            height={heigthPopUp}
            width={widthPopUp}
            onlyHidden={showNotData}
            isDisabledButton={isDisabledButton}
            isLoading={loading}
            leftButtonContent={<RequiredFieldsMessage />}
        />
    );
};
